import React, { useCallback } from "react";
import {
  PurchasedModalContents,
  ContentsWrap,
  ModalCloseButton,
  PriceLabel,
  PurchasedRequest,
  SelectedNameLabel,
  SelectedNameWrap,
  SelectedSpecItem,
  SelectedSpecWrap,
  CalendarSettingModalWrap,
  SelectedGBLabel,
  PriceLabelWrap,
  CloseButton,
  SpecLabel,
  DoubleLinePriceLabel,
  SpecLabelDescription,
  AppealPriceLabel,
  Border,
  PriceTextLabel,
} from "./elements";
import { Spec } from "../PurchasedList";
import { useNavigate } from "react-router-dom";
import Close from "../../assets/images/close.svg";

export interface CheckBox {
  label: string;
  checked: boolean;
}

export interface Props {
  series: string;
  selectedName: string;
  selectSpec: Spec | undefined;
  setIsModalOpen: React.Dispatch<React.SetStateAction<boolean>>;
}

export const PurchasedModal: React.FC<Props> = ({
  series,
  selectedName,
  selectSpec,
  setIsModalOpen,
}) => {
  const navigate = useNavigate();

  const onModalClose = useCallback(() => {
    setIsModalOpen(false);
  }, [setIsModalOpen]);

  const onPurchasedRequest = useCallback(
    (condition: string) => {
      navigate("/purchased_form", {
        state: {
          series: series,
          name: selectedName,
          gb: selectSpec?.gb,
          condition: condition,
        },
      });
      setIsModalOpen(false);
    },
    [navigate, selectSpec?.gb, selectedName, series, setIsModalOpen]
  );

  if (!selectSpec) {
    return null;
  }

  return (
    <CalendarSettingModalWrap>
      <PurchasedModalContents>
        <ModalCloseButton onClick={onModalClose}>
          <CloseButton src={Close} />
        </ModalCloseButton>
        <ContentsWrap>
          <AppealPriceLabel>
            OPEN記念キャンペーン買取価格10%UP中
          </AppealPriceLabel>
          <SelectedNameWrap>
            <SelectedNameLabel>{selectedName}</SelectedNameLabel>
            <SelectedGBLabel>{selectSpec.gb}</SelectedGBLabel>
          </SelectedNameWrap>
          <SelectedSpecWrap>
            <SpecLabel>使用感が少なく傷はない</SpecLabel>
            <SelectedSpecItem>
              <PriceLabelWrap>
                {selectSpec.someScratches !== "" && (
                  <DoubleLinePriceLabel>
                    最大
                    {(
                      parseFloat(
                        selectSpec.noScratches.replace(/[^\d.]/g, "")
                      ) * 0.9
                    ).toFixed(0)}
                    円
                  </DoubleLinePriceLabel>
                )}
                {selectSpec.noScratches === "" ? (
                  <PriceTextLabel>査定時にメールにて確定</PriceTextLabel>
                ) : (
                  <PriceLabel>{selectSpec.noScratches}</PriceLabel>
                )}
              </PriceLabelWrap>
              <PurchasedRequest
                onClick={() => onPurchasedRequest("noScratches")}
              >
                申し込み
              </PurchasedRequest>
            </SelectedSpecItem>
            <Border />
            <SpecLabel>使用感はあるが目立つ傷はない</SpecLabel>
            <SelectedSpecItem>
              <PriceLabelWrap>
                {selectSpec.someScratches !== "" && (
                  <DoubleLinePriceLabel>
                    最大
                    {(
                      parseFloat(
                        selectSpec.someScratches.replace(/[^\d.]/g, "")
                      ) * 0.9
                    ).toFixed(0)}
                    円
                  </DoubleLinePriceLabel>
                )}
                {selectSpec.someScratches === "" ? (
                  <PriceTextLabel>査定時にメールにて確定</PriceTextLabel>
                ) : (
                  <PriceLabel>{selectSpec.someScratches}</PriceLabel>
                )}
              </PriceLabelWrap>
              <PurchasedRequest
                onClick={() => onPurchasedRequest("someScratches")}
              >
                申し込み
              </PurchasedRequest>
            </SelectedSpecItem>
            <Border />
            <SpecLabel>目立つ傷がある</SpecLabel>
            <SelectedSpecItem>
              <PriceLabelWrap>
                {selectSpec.noticeableScratches !== "" && (
                  <DoubleLinePriceLabel>
                    最大
                    {(
                      parseFloat(
                        selectSpec.noticeableScratches.replace(/[^\d.]/g, "")
                      ) * 0.9
                    ).toFixed(0)}
                    円
                  </DoubleLinePriceLabel>
                )}
                {selectSpec.noticeableScratches === "" ? (
                  <PriceTextLabel>査定時にメールにて確定</PriceTextLabel>
                ) : (
                  <PriceLabel>{selectSpec.noticeableScratches}</PriceLabel>
                )}
              </PriceLabelWrap>
              <PurchasedRequest
                onClick={() => onPurchasedRequest("noticeableScratches")}
              >
                申し込み
              </PurchasedRequest>
            </SelectedSpecItem>
            <Border />
            <SpecLabel>画面割れ・機能ジャンク品</SpecLabel>
            <SelectedSpecItem>
              <PriceLabelWrap>
                {selectSpec.crackedScreen !== "" && (
                  <DoubleLinePriceLabel>
                    最大
                    {(
                      parseFloat(
                        selectSpec.crackedScreen.replace(/[^\d.]/g, "")
                      ) * 0.9
                    ).toFixed(0)}
                    円
                  </DoubleLinePriceLabel>
                )}
                {selectSpec.crackedScreen === "" ? (
                  <PriceTextLabel>査定時にメールにて確定</PriceTextLabel>
                ) : (
                  <PriceLabel>{selectSpec.crackedScreen}</PriceLabel>
                )}
              </PriceLabelWrap>
              <PurchasedRequest
                onClick={() => onPurchasedRequest("crackedScreen")}
              >
                申し込み
              </PurchasedRequest>
            </SelectedSpecItem>
            <SpecLabelDescription>
              ※動作異常／各種ボタン不良／指紋認証不良／顔認証不良／カメラレンズ割れ／カメラ動作不良／タッチ動作不良
            </SpecLabelDescription>
          </SelectedSpecWrap>
        </ContentsWrap>
      </PurchasedModalContents>
    </CalendarSettingModalWrap>
  );
};

PurchasedModal.displayName = "PurchasedModal";
